module.exports = __webpack_public_path__ + "img/002-size.f30a28b8.svg";